"use client";

import React, { ReactNode } from "react";
import { SessionProvider } from "next-auth/react";

interface KeycloakSessionProviderProps {
  children: ReactNode;
}

const KeycloakSessionProvider: React.FC<KeycloakSessionProviderProps> = ({
  children,
}) => {
  return <SessionProvider>{children}</SessionProvider>;
};

export default KeycloakSessionProvider;
